import React, { useContext, createContext, useState, useEffect } from 'react';
import axios from 'axios';

const RestaurantsContext = createContext();

const RestaurantsProvider = ({ children }) => {
	const [restaurants, setRestaurants] = useState([]);
	const [selectedRestaurant, setSelectedRestaurant] = useState(() => {
		return JSON.parse(sessionStorage.getItem('selectedRestaurant')) || null;
	});

	// Fonction pour rafraîchir les données du restaurant sélectionné
	const refreshSelectedRestaurant = async () => {
		if (!selectedRestaurant || !selectedRestaurant.id) return;

		try {
			const response = await axios.get(
				`${import.meta.env.VITE_API_URL}/api/back-office/restaurants/${selectedRestaurant.id}/view`
			);

			if (response.status === 200 && response.data) {
				// Mettre à jour le restaurant dans le state
				setSelectedRestaurant({
					...selectedRestaurant,
					...response.data,
				});
			}
		} catch (error) {
			console.error('Erreur lors du rafraîchissement du restaurant:', error);
		}
	};

	useEffect(() => {
		if (restaurants.length > 0 && !(restaurants.length > 1)) {
			setSelectedRestaurant(restaurants[0]);

			return;
		}

		if (restaurants.length > 1 && !selectedRestaurant) {
			setSelectedRestaurant(restaurants.find((restaurant) => restaurant.is_default));

			return;
		}
	}, [restaurants]);

	useEffect(() => {
		if (selectedRestaurant) {
			sessionStorage.setItem('selectedRestaurant', JSON.stringify(selectedRestaurant));
		}
	}, [selectedRestaurant]);

	return (
		<RestaurantsContext.Provider value={{
			restaurants,
			setRestaurants,
			selectedRestaurant,
			setSelectedRestaurant,
			refreshSelectedRestaurant
		}}>
			{children}
		</RestaurantsContext.Provider>
	);
};

const useRestaurantsContext = () => useContext(RestaurantsContext);

export { RestaurantsProvider, useRestaurantsContext };
